var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-form" }, [
    _c(
      "form",
      {
        style: { filter: _vm.isProcessing ? "blur(2px)" : "none" },
        attrs: { novalidate: "" },
        on: {
          submit: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm.isProcessing
      ? _c(
          "div",
          { staticClass: "ui-form__processing" },
          [_c("ui-progress", { attrs: { diameter: 60, stroke: 2 } })],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }